export default __webpack_public_path__ + "static/media/tms-signaling.c4c6b059.pdf";